
const Popup = resolve => {
    require.ensure(['../views/apps/popup/Popup'], () => {
        resolve(require('../views/apps/popup/Popup'))
    })
};

const PopupTanimla = resolve => {
    require.ensure(['../views/apps/popup/PopupTanimla'], () => {
        resolve(require('../views/apps/popup/PopupTanimla'))
    })
};

const PopupListe = resolve => {
    require.ensure(['../views/apps/popup/PopupListe'], () => {
        resolve(require('../views/apps/popup/PopupListe'))
    })
};
const PopupDuzenle = resolve => {
    require.ensure(['../views/apps/popup/PopDuzenle'], () => {
        resolve(require('../views/apps/popup/PopDuzenle'))
    })
};
import Vue from 'vue'

Vue.component('PopupTanimla', PopupTanimla);
Vue.component('PopupListe', PopupListe);
Vue.component('PopupDuzenle', PopupDuzenle);


import layouts from '../layout'

export default {
    path: '/popup',
    name: 'popup',
    component: Popup,
    meta: {
        auth: true,
        layout: layouts.navLeft
    },
    children: [
        {
            path: 'tanimla',
            name: 'popuptanimla',
            component: PopupTanimla,
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                tags: ['app']
            }
        },
        {
            path: 'liste',
            name: 'popupliste',
            component: PopupListe,
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                tags: ['app']
            }
        },
        {
            path: 'guncelleme',
            name: 'popupguncelle',
            component: PopupDuzenle,
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                tags: ['app']
            }
        },
    ]
}
